import { render, staticRenderFns } from "./CompareComp.vue?vue&type=template&id=5879bab5&"
import script from "./CompareComp.vue?vue&type=script&lang=js&"
export * from "./CompareComp.vue?vue&type=script&lang=js&"
import style0 from "./CompareComp.vue?vue&type=style&index=0&id=5879bab5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports